import React, { useState, useContext, useEffect } from 'react';
import useCMS from '../../hooks/useCMS';
import useLog from '../../hooks/useLog';
import {CloudQueue} from '@mui/icons-material';
import { CMSContext } from '../../contexts/CMSContext';
import { UserContext } from '../../contexts/UserContext';


const CmsStatus = () => {
  const { MAC, token, buildingIdList} = React.useContext(CMSContext);
  const { LogInfo, LogError, LogVerbose } = useLog();
  const {userId} = useContext(UserContext);
  const [status, setStatus] = useState('Checking'); //track the status of the CMS to adjust the icon color
  
  const { buildingIds} = useContext(CMSContext);

  const {FetchBuildingData,GetTokenForUser } = useCMS();

  //when buildingIds is set (through token) get building data
  useEffect(() => {
    if (buildingIds.length > 0) {
      LogVerbose('useCMS: buildingIds set (length: '+buildingIds.length+'), fetching building data');
      FetchBuildingData(buildingIds, userId);
    }
  }, [buildingIds]);

  //if token is received, set status to online
  useEffect(() => {
    if(token){
      setStatus('Online');
    }else{
      setStatus('Offline');
    }
  }, [token]);


  return (
    <div>
      {status === 'Online' ? <CloudQueue style={{color: 'green', transform: 'scale(0.7)'}}/> :  status === 'Checking' ? <CloudQueue style={{color: 'orange', transform: 'scale(0.7)'}}/> : <CloudQueue style={{color: 'red', transform: 'scale(0.7)'}}/>}
    </div>
  );
};

export default CmsStatus;